import { useQuery } from "@tanstack/react-query";

import { fetchGuestPassHistory } from "@/services/finance";

export const GuestPassHistoryQueryKey = ["guestPassHistory"];

export const useGuestPassHistory = () => {
  const guestPasses = useQuery({
    queryKey: GuestPassHistoryQueryKey,
    queryFn: fetchGuestPassHistory,
  });
  return { guestPasses };
};
